import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

export default function BlankLayout({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

BlankLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
